// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export var BasicEnrollmentEthnicity;
(function (BasicEnrollmentEthnicity) {
    BasicEnrollmentEthnicity["Hispanic"] = "H";
    BasicEnrollmentEthnicity["NotHispanic"] = "N";
    BasicEnrollmentEthnicity["NoAnswer"] = "X";
})(BasicEnrollmentEthnicity || (BasicEnrollmentEthnicity = {}));
//# sourceMappingURL=basicEnrollmentEthnicity.js.map